import script from "./FighterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FighterCard.vue?vue&type=script&setup=true&lang=js"

import "./FighterCard.vue?vue&type=style&index=0&id=370344c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370344c2"]])

export default __exports__